import { overlay } from 'overlay-kit';
import '@/shared/features/quiz-folder/consts/events.quiz-folder';
import { trackEvent } from '@zep/logger/tracking';
import type { FolderCreatePlace } from '@/shared/features/quiz-folder/consts/events.quiz-folder';
import type { Folder } from './types/folder.types';

/**
 * 폴더 만들기 모달을 연다.
 *
 * `onCreated` 를 주면 만든 폴더를 그쪽으로 넘기고 이동하지 않는다.
 */
export async function showCreateFolderModal({
  place,
  onCreated
}: {
  /** 만들기를 시작한 자리. */
  place: FolderCreatePlace;
  onCreated?: (folder: Folder) => void;
}) {
  const {
    CreateFolderModal
  } = await import('./components/CreateFolderModal');
  trackEvent('quiz_folder_create_modal_open', {
    place
  });
  overlay.open(({
    unmount
  }) => <CreateFolderModal place={place} onClose={unmount} onCreated={onCreated} />, {
    overlayId: 'create-folder-modal'
  });
}